  <template>
    <div class="products-page" >
      <!-- 顶部导航 -->
      <Headers />

      <!-- 页面标题 -->
      <section class="page-hero">
        <div class="hero-container">
          <h1>开箱即用，助你专注AI核心价值</h1>
          <p>无需繁琐搭建，快速启动AI项目，释放创新潜能。</p>
        </div>
      </section>


      <!-- 产品3: 轻量级算力租赁 -->
      <section class="product-section" id="power-rent">
        <div class="product-container">
          <div class="product-header">
            <div class="product-info">
              <div class="product-icon">
                <i class="el-icon-lightning"></i>
              </div>
              <div>
                <h2>轻量级算力租赁</h2>
                <p class="product-tagline">灵活掌控算力，按需扩展资源</p>
              </div>
            </div>
          </div>

          <div class="product-content">
            <div class="content-grid">
              <div class="content-left">
                <h3>按需调用的智能算力平台</h3>
                <p class="description">
                  为您提供灵活可控的计算能力，定制化算力需求，让AI开发更轻松、更高效。
                </p>


                <div class="features-list">
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>资源随需而配</h4>
                      <p>GPU、CPU、存储按任务需求自由组合，轻量起步，按需扩展。</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>环境自主掌控</h4>
                      <p>支持上传私有镜像，自由安装框架与依赖，打造专属运行环境。</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>用多少付多少</h4>
                      <p>资源使用精准计费，避免闲置浪费，降低训练与推理成本。</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>数据安全可靠</h4>
                      <p>资源独立分配，任务彼此隔离，保障数据隐私与系统稳定。</p>
                    </div>
                  </div>
                </div>

                <!--              <div class="compute-features">
                <div class="feature-group">
                  <h4>环境完全自定义</h4>
                  <ul>
                    <li>支持上传私有计算镜像</li>
                    <li>可预装任意框架版本及依赖库</li>
                    <li>调试模式开放SSH终端权限，直接修改容器内配置</li>
                  </ul>
                </div>

                <div class="feature-group">
                  <h4>多维度资源扩展</h4>
                  <ul>
                    <li><strong>垂直扩展：</strong>单任务独占多GPU</li>
                    <li><strong>水平扩展：</strong>动态追加计算节点</li>
                    <li><strong>存储扩展：</strong>临时挂载高速云盘</li>
                  </ul>
                </div>

                <div class="feature-group">
                  <h4>底层技术开放</h4>
                  <ul>
                    <li>查看实时硬件指标：GPU显存占用、CPU指令集利用率</li>
                    <li>自定义任务调度策略：抢占式/独占式/混合式资源分配</li>
                    <li>多协议接入：支持Kubectl管控任务，技术文档定向开放</li>
                  </ul>
                </div>
              </div>-->
              </div>

              <div class="content-right">
                <div class="gpu-showcase">
                  <h4>高性价比算力推荐</h4>
                  <div class="gpu-cards">
                    <div class="gpu-card">
                      <div class="gpu-name">RTX 4090</div>
                      <div class="gpu-specs">
                        <div class="spec-item">
                          <span class="spec-label">价格</span>
                          <span class="gpu-price">￥3.12/卡/小时</span>
                        </div>
                        <div class="spec-item">
                          <span class="spec-label">显存</span>
                          <span class="spec-value">24GB GDDR6</span>
                        </div>
                        <div class="spec-item">
                          <span class="spec-label">算力</span>
                          <span class="spec-value">8.1 TFLOPS</span>
                        </div>
                        <div class="spec-item">
                          <span class="spec-label">适用场景</span>
                          <span class="spec-value">推理/轻量训练</span>
                        </div>
                        <div class="gpu-price btn">
                          <button class="main-btn main-btn-small " @click="goToProducts">
                            <a>立即购买</a>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="gpu-card featured">
                      <div class="gpu-name">RTX 5090</div>
                      <div class="gpu-specs">
                        <div class="spec-item">
                          <span class="spec-label">价格</span>
                          <span class="gpu-price">￥4.12/卡/小时</span>
                        </div>
                        <div class="spec-item">
                          <span class="spec-label">显存</span>
                          <span class="spec-value">48GB GDDR6</span>
                        </div>
                        <div class="spec-item">
                          <span class="spec-label">算力</span>
                          <span class="spec-value">8.1 TFLOPS</span>
                        </div>
                        <div class="spec-item">
                          <span class="spec-label">适用场景</span>
                          <span class="spec-value">中等规模训练</span>
                        </div>
                      </div>
                      <div class="gpu-price btn">
                        <button class="main-btn main-btn-small " @click="goToProducts">
                          <a>立即购买</a>
                        </button>
                      </div>
                      <div class="gpu-badge">均衡之选</div>
                    </div>
                    <div class="gpu-price" style="font-size: 14px;color: #fff;">查看更多>></div>

                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>

      <section class="products-section" ref="productsSection" >
        <div class="products-container">
          <!--        <h2 class="section-title">核心产品矩阵</h2>-->
          <div class="products-grid">
            <div class="product-card">
              <div class="product-icon">
                <i class="el-icon-box xc-icon"></i>
              </div>
              <h3>敏捷协作的AI开发体验</h3>
              <p class="product-subtitle">秒级启动，轻松开发</p>
              <div class="product-features">
                <div class="feature-item">
                  <span class="feature-label">启动速度：</span>
                  <span class="feature-value">≤20秒</span>
                </div>
                <div class="feature-item">
                  <span class="feature-label">支持框架：</span>
                  <span class="feature-value">4+ 主流框架</span>
                </div>
              </div>
              <div class="product-highlights">
                <div class="highlight-item">
                  <i class="el-icon-check"></i>
                  <span>一键部署，无需配置</span>
                </div>
                <div class="highlight-item">
                  <i class="el-icon-check"></i>
                  <span>多框架兼容，无缝切换</span>
                </div>
              </div>
              <button class="main-btn main-btn-small  sm2" @click="goToProducts">
                <a>立即体验</a>
              </button>
            </div>

            <!-- 零部署模型服务 -->
            <div class="product-card">
              <div class="product-icon">
                <i class="el-icon-cpu xc-icon"></i>
              </div>
              <h3>即开即用的模型生态体系</h3>
              <p class="product-subtitle">API直连，免运维推理</p>
              <div class="product-features">
                <div class="feature-item">
                  <span class="feature-label">预置模型：</span>
                  <span class="feature-value">100+</span>
                </div>
                <div class="feature-item">
                  <span class="feature-label">调用方式：</span>
                  <span class="feature-value">Web+API</span>
                </div>
              </div>
              <div class="product-highlights">
                <div class="highlight-item">
                  <i class="el-icon-check"></i>
                  <span>即插即用，快速上手</span>
                </div>
                <div class="highlight-item">
                  <i class="el-icon-check"></i>
                  <span>高效数据交互，流畅体验</span>
                </div>
              </div>
              <button class="main-btn main-btn-small  sm2" @click="goToProducts">
                <a>立即体验</a>
              </button>
            </div>

            <!-- 轻量级算力租赁 -->
            <div class="product-card">
              <div class="product-icon">
                <i class="el-icon-lightning xc-icon"></i>
              </div>
              <h3>灵活安全的算力管理平台</h3>
              <p class="product-subtitle">灵活掌控算力，按需扩展资源</p>
              <div class="product-features">
                <div class="feature-item">
                  <span class="feature-label">GPU规格：</span>
                  <span class="feature-value">RTX系列</span>
                </div>
                <div class="feature-item">
                  <span class="feature-label">计费模式：</span>
                  <span class="feature-value">按需付费</span>
                </div>
              </div>
              <div class="product-highlights">
                <div class="highlight-item">
                  <i class="el-icon-check"></i>
                  <span>按需租赁，灵活扩展</span>
                </div>
                <div class="highlight-item">
                  <i class="el-icon-check"></i>
                  <span>全方位安全保障，放心使用</span>
                </div>
              </div>
              <button class="main-btn main-btn-small  sm2" @click="goToProducts">
                <a>立即体验</a>
              </button>
            </div>
          </div>
        </div>
      </section>



      <!-- 产品1: 预装框架容器 -->
      <section class="product-section" id="container">
        <div class="product-container">
          <div class="product-header">
            <div class="product-info">
              <div class="product-icon">
                <i class="el-icon-box xc-icon"></i>
              </div>
              <div>
                <h2>预装框架容器</h2>
                <p class="product-tagline">秒级启动，零配置开发</p>
              </div>
            </div>
          </div>

          <div class="product-content">
            <div class="content-grid">
              <div class="content-left">
                <h3>开箱即用的AI开发环境</h3>
                <p class="description">
                  快速启动你的AI项目，无需繁琐配置。我们的平台提供一站式解决方案，让你专注于创新与开发。
                </p>

                <div class="features-list">
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>一键部署，轻松上手</h4>
                      <p>预装主流框架：PyTorch、TensorFlow等热门工具已预装，开箱即用。</p>
                      <p>告别复杂设置：只需简单几步，即可开始模型训练和测试。</p>
                    </div>
                  </div>
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>环境快照，随时恢复</h4>
                      <p>保存进度，无忧切换：支持环境快照，一键还原到任何开发状态，再也不怕意外丢失工作成果。</p>
                    </div>
                  </div>
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>多人协作，无缝对接</h4>
                      <p>实时共享，高效沟通：多人共享容器，实时同步代码变更，团队合作更顺畅。</p>
                    </div>
                  </div>
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>高效资源，灵活选择</h4>
                      <p>多种GPU配置：根据需求选择合适的GPU型号，无论是轻量级推理还是大规模训练，都能满足你的需求。</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="content-right">
                <div class="gpu-showcase">
                  <h4>精选套餐推荐</h4>
                  <div class="gpu-cards">

                    <!-- 新增的一行双卡布局 -->
                    <div class="gpu-cards-row">
                      <!-- GPU卡1 -->
                      <div class="gpu-card">
                        <div class="gpu-name">推理/轻量训练</div>
                        <div class="gpu-specs">
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">GPU型号</span>
                            <span class="spec-value">RTX 4090</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">单卡算力</span>
                            <span class="spec-value">8.1 TFLOPS</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">显存</span>
                            <span class="spec-value">24GB GDDR6</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">配套CPU/内存</span>
                            <span class="spec-value">64vCPU/512GB</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">存储</span>
                            <span class="spec-value">100GB SSD</span>
                          </div>

                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">价格</span>
                            <div class="price-group">
                              <span class="original-price">￥3.12/卡/小时</span>
                              <span class="discounted-price">￥2.12/卡/小时</span>
                            </div>
                          </div>

                          <div class="gpu-price" style="margin-top: 30px;">
                            <button class="main-btn main-btn-small  sm2" @click="goToProducts">
                              <a>立即购买</a>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- GPU卡2 -->
                      <div class="gpu-card">
                        <div class="gpu-name">中等规模训练/渲染</div>
                        <div class="gpu-specs">
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">GPU型号</span>
                            <span class="spec-value">RTX 5090</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">单卡算力</span>
                            <span class="spec-value">31.2 TFLOPS</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">显存</span>
                            <span class="spec-value">32GB GDDR6</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">配套CPU/内存</span>
                            <span class="spec-value">64vCPU/512GB</span>
                          </div>
                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">存储</span>
                            <span class="spec-value">100GB SSD</span>
                          </div>

                          <div class="spec-item" style="margin-top: 30px;">
                            <span class="spec-label">价格</span>
                            <div class="price-group">
                              <span class="original-price">￥4.12/卡/小时</span>
                              <span class="discounted-price">￥3.12/卡/小时</span>
                            </div>
                          </div>

                          <div class="gpu-price" style="margin-top: 30px;">
                            <button class="main-btn main-btn-small  sm2" @click="goToProducts">
                              <a>立即购买</a>
                            </button>
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- 其他卡片保持原样 -->
                    <div class="gpu-price" style="font-size: 14px;color: #fff;">查看更多>></div>

                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </section>

      <!-- 产品2: 零部署模型服务 -->
      <section class="product-section alt" id="model-service">
        <div class="product-container">
          <div class="product-header">
            <div class="product-info">
              <div class="product-icon">
                <i class="el-icon-cpu"></i>
              </div>
              <div>
                <h2>零部署模型服务</h2>
                <p class="product-tagline">API直连，免运维推理</p>
              </div>
            </div>
          </div>

          <div class="product-content">
            <div class="content-grid">
              <div class="content-left">
                <h3>触手可及的AI模型服务</h3>
                <p class="description">
                  平台提供多样化的托管模型，覆盖主流任务场景，支持灵活配置与一键部署，让AI模型像插件一样随取随用。
                </p>

                <div class="features-list">
                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>丰富模型，开箱即用</h4>
                      <p>平台内置图像识别、自然语言处理、推荐系统等多个领域的热门模型，持续更新，覆盖主流AI场景。只需简单选择与配置，即可使用。</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>一键部署，轻松上线</h4>
                      <p>选模型 + 配参数 → 点击部署，系统自动完成服务上线，省去手动搭建与调试流程，快速进入测试或生产阶段。</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>灵活调用，无缝集成</h4>
                      <p>支持Web界面交互与标准API接口调用，既能可视化操作，也能对接自有系统，满足不同场景下的使用需求。</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <i class="el-icon-check"></i>
                    <div>
                      <h4>安全私有，高效验证</h4>
                      <p>模型运行于独立容器中，数据全程隔离，保障隐私与安全。资源按需分配，精准计费，助力快速验证效果，降低试错成本。</p>
                    </div>
                  </div>
                </div>

              </div>

              <div class="content-right">
                <div class="gpu-showcase">
                  <h4>热门模型推荐</h4>
                  <div class="gpu-cardss">
                    <!-- 模型1 -->
                    <div class="gpu-card">
                      <div class="gpu-name">DeepSeek-R1</div>
                      <div class="model-tag">强化学习</div> <!-- 标签 -->
                      <div class="model-type">推理模型</div> <!-- 类型 -->
                      <div class="gpu-specs">
                        <div class="spec-item">
                          <span class="spec-label">强化学习驱动的推理模型，解决重复性和可速性问题。</span>
                        </div>
                      </div>
                      <button class="main-btn main-btn-small  sm3" @click="goToProducts">
                        <a>立即购买</a>
                      </button>
                    </div>

                    <!-- 模型2 -->
                    <div class="gpu-card">
                      <div class="gpu-name">ChatGLM-3</div>
                      <div class="model-tag">对话理解</div>
                      <div class="model-type">多语言模型</div>
                      <div class="gpu-specs">
                        <div class="spec-item">
                          <span class="spec-label">支持多语言对话理解与生成，适用于客服、助手等场景。</span>
                        </div>
                      </div>
                      <button class="main-btn main-btn-small  sm3" @click="goToProducts">
                        <a>立即购买</a>
                      </button>
                    </div>

                    <!-- 模型3 -->
                    <div class="gpu-card">
                      <div class="gpu-name">Stable Diffusion v4</div>
                      <div class="model-tag">图像生成</div>
                      <div class="model-type">视觉创作</div>
                      <div class="gpu-specs">
                        <div class="spec-item">
                          <span class="spec-label">图像生成模型，支持高质量图像创作和文本到图像转换。</span>
                        </div>
                      </div>
                      <button class="main-btn main-btn-small  sm3" @click="goToProducts">
                        <a>立即购买</a>
                      </button>
                    </div>

                    <!-- 模型4 -->
                    <div class="gpu-card featured">
                      <div class="gpu-name">Qwen-Max</div>
                      <div class="model-tag">逻辑推理</div>
                      <div class="model-type">大语言模型</div>
                      <div class="gpu-specs">
                        <div class="spec-item">
                          <span class="spec-label">阿里通义千问系列大模型，适合复杂任务和逻辑推理。</span>
                        </div>
                      </div>
                      <button class="main-btn main-btn-small  sm3" @click="goToProducts">
                        <a>立即购买</a>
                      </button>
                      <div class="gpu-badge">推荐</div>
                    </div>

                    <!-- 模型5
                  <div class="gpu-card">
                    <div class="gpu-name">Llama-3</div>
                    <div class="model-tag">自然语言处理</div>
                    <div class="model-type">开源大模型</div>
                    <div class="gpu-specs">
                      <div class="spec-item">
                        <span class="spec-label">Meta 开源大语言模型，支持多种自然语言理解和生成任务。</span>
                      </div>
                    </div>
                    <el-button type="primary" size="small" style="background-color: #fff;border-color: #fff">立即购买</el-button>
                  </div>-->

                    <!-- 模型6
                  <div class="gpu-card">
                    <div class="gpu-name">Bloom-176B</div>
                    <div class="model-tag">多语言翻译</div>
                    <div class="model-type">超大规模模型</div>
                    <div class="gpu-specs">
                      <div class="spec-item">
                        <span class="spec-label">大规模多语言语言模型，支持 46 种语言，适用于翻译、对话生成等复杂任务。</span>
                      </div>
                    </div>
                    <el-button type="primary" size="small" style="background-color: #fff;border-color: #fff">立即购买</el-button>
                  </div>-->
                    <div class="gpu-price" style="font-size: 14px;color: #fff;">查看更多>></div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <!-- CTA区域 -->
      <section class="cta-section">
        <div class="cta-container">
          <h2>准备开始您的AI项目？</h2>
          <p>选择适合的产品方案，立即开始体验</p>
          <div class="cta-actions">
            <button class="main-btn main-btn-large " @click="goToRegister">
             
              <a> <i class="el-icon-user"></i> 免费注册</a>
            </button>
            <button class="main-btn main-btn-large " @click="goToPricing">
             
              <a> <i class="el-icon-price-tag"></i> 查看定价</a>
            </button>
          </div>
        </div>
      </section>

    <Footer />
    </div>
  </template>

<script>
import Headers from '@/components/headers.vue'
import Footer from '@/components/footer.vue'
export default {
  name: 'OfficialProducts',
  components: {
    Headers,
    Footer
  },
  data() {
    return {
    }
  },
  methods: {
    goToRegister() {
      window.open('/login', '_blank')
    },
    goToPricing() {
      this.$router.push('/official/pricing')
    },
    goToProducts() {
      this.$router.push('/official/products')
    }
  }
}
</script>

<style lang="scss" scoped>
.products-page {
  min-height: 100vh;
  background: #0a0e1a;
  color: #ffffff;
}



// 页面英雄区域
.page-hero {
  padding: 140px 20px 80px;
  background: radial-gradient(ellipse at center, rgba(102, 126, 234, 0.15) 0%, rgba(10, 14, 26, 1) 70%);
  text-align: center;

  .hero-container {
    max-width: 800px;
    margin: 0 auto;

    h1 {
      font-size: 48px;
      font-weight: 700;
      margin: 0 0 24px;
      background: #fff;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      font-size: 20px;
      color: #fff;
      margin: 0;
    }
  }
}

// 产品区域
.product-section {
  padding: 100px 20px;
  background: #000;

  &.alt {
    background: #0d0d12;
  }

  .product-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .product-header {
    margin-bottom: 60px;

    .product-info {
      display: flex;
      align-items: center;
      gap: 24px;

      .product-icon {
        width: 80px;
        height: 80px;
        // background: linear-gradient(135deg, #fff, #764ba2);
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 36px;
          color: white;
        }
      }

      h2 {
        font-size: 36px;
        font-weight: 700;
        margin: 0 0 8px;
        color: #ffffff;
      }

      .product-tagline {
        font-size: 18px;
        font-weight: 600;
        margin: 0;
      }
    }
  }

  .product-content {
    .content-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 60px;
      align-items: start;
    }

    h3 {
      font-size: 28px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    .description {
      font-size: 16px;
      color: #fff;
      line-height: 1.6;
      margin-bottom: 40px;
    }
  }
}

// 特性列表
.features-list {
  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 24px;

    i {
      color: #fff;
      font-size: 20px;
      margin-top: 2px;
      flex-shrink: 0;
    }

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin: 0 0 4px;
    }

    p {
      color: #fff;
      margin: 0;
      line-height: 1.4;
    }
  }
}

// 统计卡片
.stats-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;

  .stat-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 24px;
    text-align: center;

    .stat-number {
      font-size: 28px;
      font-weight: 700;
      color: #fff;
      margin-bottom: 8px;
    }

    .stat-label {
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 4px;
    }

    .stat-desc {
      font-size: 12px;
      color: #8892b0;
    }
  }
}

// 框架展示
.frameworks-showcase {
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .framework-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    .framework-item {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      padding: 16px;
      text-align: center;
      font-weight: 600;
      font-size: 14px;

      &.pytorch {
        color: #ff6b35;
      }

      &.tensorflow {
        color: #ff6f00;
      }

      &.paddlepaddle {
        color: #0052cc;
      }

      &.mindspore {
        color: #3f51b5;
      }
    }
  }
}

// 模型类型
.model-types {
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .model-categories {
    .model-category {
      margin-bottom: 20px;

      h5 {
        font-size: 16px;
        color: #8892b0;
        margin: 0 0 12px;
      }

      .model-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .model-tag {
          background: rgba(102, 126, 234, 0.2);
          color: #fff;
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
}

// 使用模式
.usage-modes {
  margin-bottom: 40px;

  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .mode-cards {
    display: grid;
    gap: 20px;

    .mode-card {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      padding: 20px;

      .mode-icon {
        width: 40px;
        height: 40px;
        background: linear-gradient(135deg, #fff, #764ba2);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;

        i {
          font-size: 20px;
          color: white;
        }
      }

      h5 {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin: 0 0 12px;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          color: #8892b0;
          font-size: 14px;
          margin-bottom: 4px;

          &:before {
            content: '•';
            color: #fff;
            margin-right: 8px;
          }
        }
      }
    }
  }
}

// 计算特性
.compute-features {
  .feature-group {
    margin-bottom: 32px;

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin: 0 0 16px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        color: #8892b0;
        line-height: 1.6;
        margin-bottom: 8px;
        padding-left: 16px;
        position: relative;

        &:before {
          content: '▸';
          color: #fff;
          position: absolute;
          left: 0;
        }

        strong {
          color: #ffffff;
        }
      }
    }
  }
}

// GPU展示
.gpu-showcase {
  margin-bottom: 40px;

  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .gpu-cards ,.gpu-cardss {
    display: grid;
    gap: 16px;

    .gpu-card {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      padding: 20px;
      position: relative;

      &.featured {
        border-color: #da2e7688;
      }

      .gpu-name {
        font-size: 18px;
        font-weight: 700;
        color: #ffffff;
        margin-bottom: 12px;
      }

      .gpu-specs {
        margin-bottom: 16px;

        .spec-item {
          display: flex;
          
          justify-content: space-between;
          margin-bottom: 8px;

          .spec-label {
            color: #fff;
            margin-top: 5px;
            font-size: 12px;
            letter-spacing: 1px;
          }

          .spec-value {
            color: #ffffff;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }

      .gpu-price {
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        cursor: pointer;
        &.btn{
          margin-top: 10px;
        }
      }

      .gpu-badge {
        position: absolute;
        top: 2px;
        right: 2px;
        // background: #FFD700; // 亮金色
        color: #da2e76;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}

// 计费模式
.billing-modes {
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px;
  }

  .billing-options {
    .billing-option {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;

      .billing-icon {
        width: 40px;
        height: 40px;
        background: linear-gradient(135deg, #fff, #764ba2);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 20px;
          color: white;
        }
      }

      h5 {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin: 0 0 4px;
      }

      p {
        color: #8892b0;
        margin: 0;
        font-size: 14px;
      }
    }
  }
}

// CTA区域
.cta-section {
  padding: 100px 20px;
  background: #0d0d12;
  text-align: center;

  .cta-container {
    max-width: 800px;
    margin: 0 auto;

    h2 {
      font-size: 36px;
      font-weight: 700;
      color: white;
      margin: 0 0 16px;
    }

    p {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0 0 40px;
    }

    .cta-actions {
      display: flex;
      justify-content: center;
      gap: 20px;

      .el-button {
        height: 50px;
        padding: 0 32px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 25px;

        &.el-button--primary {
          background: white;
          color: #fff;
          border: none;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);
          }
        }

        &:not(.el-button--primary) {
          background: transparent;
          border: 2px solid rgba(255, 255, 255, 0.5);
          color: white;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: white;
          }
        }
      }
    }
  }
}

// 页脚样式
.main-footer {
  background: #0a0e1a;
  padding: 60px 20px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }

  .footer-section {
    h4 {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    p {
      color: #8892b0;
      line-height: 1.6;
      margin: 0 0 8px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 8px;

        a {
          color: #8892b0;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      color: #8892b0;
      margin: 0;
    }
  }
}

// 响应式
@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr !important;
    gap: 40px !important;
  }

  .stats-cards {
    grid-template-columns: 1fr !important;
  }

  .framework-grid {
    grid-template-columns: 1fr !important;
  }

  .header-nav {
    display: none !important;
  }
}




.gpu-cardss {
  display: grid;
  grid-template-columns: repeat(2, 1fr); // 每行2列
  gap: 16px; // 卡片之间的间距
  .gpu-card{
    background: hsla(0, 0%, 100%, .05);
    border: 1px solid hsla(0, 0%, 100%, .1);
    border-radius: 12px;
    padding: 20px;
    position: relative;
  }
}

.model-tag,
.model-type {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 10px;
  margin-top: 8px;
  display: inline-block;
}

.model-tag {
  background-color: rgba(102, 126, 234, 0.2);
  color: #fff;
}

.model-type {
  margin-left: 3px;
  background-color: rgba(75, 192, 192, 0.2); // 可自定义颜色
  color: #da2e76;
}

.gpu-cards-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.price-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.original-price {
  font-size: 14px;
  color: #8892b0;
  text-decoration: line-through; // 删除线
}

.discounted-price {
  font-size: 20px;
  font-weight: bold;
  color: #fff; // 突出色
}

.custom-buy-btn {
  background-color: #fff !important;
  border-color: #fff !important;
  color: white !important;
  font-weight: bold;
  padding: 10px 24px; // 加宽按钮
  border-radius: 30px; // 圆角按钮
  transition: all 0.3s ease;
  width: 50%;

  &:hover {
    background-color: #5a67d8 !important; // 悬停颜色变化
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4); // 添加阴影
    transform: translateY(-2px);
  }
}

.custom-buy-btn {
  background-color: #fff !important;
  border-color: #fff !important;
  color: white !important;
  font-weight: bold;
  padding: 10px 24px; // 加宽按钮
  border-radius: 30px; // 圆角按钮
  transition: all 0.3s ease;

  &:hover {
    background-color: #5a67d8 !important; // 悬停颜色变化
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4); // 添加阴影
    transform: translateY(-2px);
  }
}


// 响应式
@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr !important;
    gap: 40px !important;
  }

  .stats-cards {
    grid-template-columns: 1fr !important;
  }

  .framework-grid {
    grid-template-columns: 1fr !important;
  }

  .header-nav {
    display: none !important;
  }
}



// 产品区域
.products-section {
  padding: 100px 20px;
  background: #000;

  .products-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    margin: 0 0 60px;
    background: linear-gradient(135deg, #fff, #764ba2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
  }

  .product-card {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 32px;
    transition: all 0.3s ease;


    .product-icon {
      width: 80px;
      height: 80px;
      // background: rgba(128, 128, 128, 0.3);
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;

      i {
        font-size: 36px;
      }
    }

    h3 {
      font-size: 24px;
      font-weight: 700;
      margin: 0 0 8px;
      color: #ffffff;
    }

    .product-subtitle {
      // color: #fff;
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 20px;
    }

    .product-features {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;

      .feature-item {
        .feature-label {
          color: #8892b0;
          font-size: 14px;
        }

        .feature-value {
          color: #fff;
          font-weight: 600;
          font-size: 16px;
        }
      }
    }

    .product-description {
      color: #fff;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .product-highlights {
      .highlight-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 12px;

        i {
          color: #fff;
          margin-top: 2px;
          flex-shrink: 0;
        }

        span {
          color: #8892b0;
          font-size: 14px;
          line-height: 1.4;
        }
      }
    }
  }
}


</style>
